interface BrandMarkProps {
  compact?: boolean;
  className?: string;
}

export function BrandMark({ compact = false, className = '' }: BrandMarkProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="LogLimit">
      <svg className="h-9 w-9 shrink-0" viewBox="0 0 36 36" aria-hidden="true">
        <rect x="1" y="1" width="34" height="34" rx="10" className="fill-slate-950 dark:fill-white" />
        <path d="M10 11v14h10M15 11h11v5" fill="none" className="stroke-white dark:stroke-slate-950" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 22h5v4h-5z" fill="#f0643d" />
      </svg>
      {!compact && <span className="text-xl font-extrabold tracking-[-0.04em] text-slate-950 dark:text-white">LogLimit</span>}
    </span>
  );
}
